<template>
  <div>
    <tab ref="tab" :tab-list="tabList" class="tab-list" />
    <section class="news-title-wrap">
      <h4 class="news-title">{{ $t('menuNewsroom.factCheck') }}</h4>
      <div class="news-title-sub">{{ $t('factCheck.title') }}</div>
    </section>

    <list-component
      :prev-route="prevRoute"
      type="fact"
      date="PublishDate"
      page-query="page"
      :size="listSize"
      @prevRouteUpdate="prevRouteUpdate"
    />
  </div>
</template>
<script>
import listPosition from '@/mixins/listPostion'

export default {
  components: {
    tab: () => import('@/components/base/Tab'),
    listComponent: () => import('@/components/base/NewsroomList'),
  },
  mixins: [listPosition],
  props: {
    tabList: {
      type: Array,
      default: function () {
        return {
          name: String,
          path: String
        }
      }
    },
    listSize: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      prevRoute: null
    }
  },
  methods: {
    prevRouteUpdate (value) {
      console.log('prevRouteUpdate fact', value)
      this.prevRoute = value
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from.name
    })
  },
}
</script>
